import { apiGet } from '../../fetch/apiService';

export function getTimeZones() {
	return apiGet('time-zones',
		null,
		{ internalApi: true }
	);
}
